export default "/images/38137695fb6061b9a9009d1316d38c0b.avif";